import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { EnrollmentModel } from "../../../domain/models/enrollment.model";
import { EnrollmentComponent } from "../EnrollmentComponent";
import { AddressInfoCardComponent } from "../../address-info-card/address-info-card.component";
import { CompanyInfoCardComponent } from "../../company-info-card/company-info-card.component";
import { PrimaryContactInfoCardComponent } from "../../primary-contact-info-card/primary-contact-info-card.component";
import { BedContactInfoComponent } from "../../bed-contact-info/bed-contact-info.component";
import { MatTabsModule } from "@angular/material/tabs";
import { EnrollmentOwnerComponent } from "../../enrollment-owner/enrollment-owner.component";
import {
  EnrollmentPropertyLicensesComponent
} from "../../enrollment-property-licenses/enrollment-property-licenses.component";
import { RentalPropertyLicenseModel } from "../../../domain/models/rental-license.model";
import {
  MgmtCompanyRentalPropertyComponent
} from "../../mgmt-company-rental-property/mgmt-company-rental-property.component";
import { MgmtCompanyLicenseComponent } from "../../mgmt-company-license/mgmt-company-license.component";
import { IndividualBedRentalComponent } from "../../individual-bed-rental/individual-bed-rental.component";
import { MatNativeDateModule } from "@angular/material/core";
import {
  EnrollmentPropertyReportingComponent
} from "../../enrollment-property-reporting/enrollment-property-reporting.component";
import {
    PropertyDetailManagedOwnerComponent
} from "../../property-detail-managed-owner/property-detail-managed-owner.component";

@Component({
  selector: 'app-individual-bed-enrollment',
  standalone: true,
    imports: [
        MatNativeDateModule,
        AddressInfoCardComponent,
        CompanyInfoCardComponent,
        PrimaryContactInfoCardComponent,
        BedContactInfoComponent,
        MatTabsModule,
        EnrollmentOwnerComponent,
        EnrollmentPropertyLicensesComponent,
        MgmtCompanyRentalPropertyComponent,
        MgmtCompanyLicenseComponent,
        IndividualBedRentalComponent,
        EnrollmentPropertyReportingComponent,
        PropertyDetailManagedOwnerComponent
    ],
  templateUrl: './individual-bed-enrollment.component.html',
  styleUrl: './individual-bed-enrollment.component.css'
})
export class IndividualBedEnrollmentComponent implements EnrollmentComponent, OnInit {
  @Input() enrollment!: EnrollmentModel;
  @ViewChild(EnrollmentOwnerComponent) ownerComponent!: EnrollmentOwnerComponent;
  @ViewChild(MgmtCompanyLicenseComponent) entityLicenseComponent!: MgmtCompanyLicenseComponent;
  @ViewChild(IndividualBedRentalComponent) rentalComponent!: IndividualBedRentalComponent;
  @ViewChild(EnrollmentPropertyReportingComponent) reportingComponent!: EnrollmentPropertyReportingComponent;
  @ViewChild(EnrollmentPropertyLicensesComponent) licenseComponent!: EnrollmentPropertyReportingComponent;
  license!: RentalPropertyLicenseModel;

  isFormValid(): boolean {
    return this.ownerComponent.isFormValid()
      && this.entityLicenseComponent.isFormValid()
      && this.rentalComponent.isFormValid()
      && this.reportingComponent.isFormValid()
      && this.licenseComponent.isFormValid();
  }

  getUpdatedEnrollment(): EnrollmentModel {
    const ownerInfo = this.ownerComponent.getUpdatedEnrollment();
    const entityLicenseInfo = this.entityLicenseComponent.getUpdatedEnrollment();
    const rentalInfo = this.rentalComponent.getUpdatedEnrollment();
    const reportingInfo = this.reportingComponent.getUpdatedEnrollment();
    const licenseInfo = this.licenseComponent.getUpdatedEnrollment();
    // Several steps return an enrollmentRentalProperty block (Rental Property carries the
    // appraiser office / jurisdiction the approver picked; Reporting carries the flags, built
    // from the ORIGINAL enrollment). A plain spread let the later step wipe the earlier one,
    // which is how the appraiser office was lost on approval. Merge the blocks instead.
    return {
      ...this.enrollment,
      ...ownerInfo,
      ...entityLicenseInfo,
      ...rentalInfo,
      ...reportingInfo,
      ...licenseInfo,
      enrollmentRentalProperty: {
        ...this.enrollment?.enrollmentRentalProperty,
        ...reportingInfo.enrollmentRentalProperty,
        ...rentalInfo.enrollmentRentalProperty, // approver's edits win over the stale copy
      },
    };
  }

  raiseFormValidations(): void {
    this.ownerComponent.raiseFormValidations();
    this.entityLicenseComponent.raiseFormValidations();
    this.rentalComponent.raiseFormValidations();
    this.reportingComponent.raiseFormValidations();
    this.licenseComponent.raiseFormValidations();
  }

  ngOnInit(): void {
    this.license = this.enrollment?.enrollmentRentalPropertyLicense ?? {};
  }
}
